import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import ExtractStepperComponent from './pdf-extract/extract-stepper.md';
import WhyExtractAPI from './pdf-extract/why-extract-api.md';
import PdfExtractResourceTitle from './pdf-extract/pdf-extract-resource-title.md';
import ExtractProductCard from './pdf-extract/extract-product.md';
import VisualizerHowItWorks from './pdf-extract/visualizer-how-it-works.md';
import PdfExtractUseCases from './pdf-extract/pdf-extract-resource.md';
import { VisualizerCustomIframeBlock } from '../../components/visualizerCustomIframe';
import { NewsLetterBlade } from '../../components/news-letter-blade';
import EsealApiAnnouncement from './e-seal-api-announcement.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const WrapperComponent = makeShortcode("WrapperComponent");
const TextBlock = makeShortcode("TextBlock");
const DCSummaryBlock = makeShortcode("DCSummaryBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Hero slots="heading, text, assetsImg, buttons" customLayout primaryOutline variant="fullwidth" variantsTypeSecondary='primary' className="herobgImage Hero-Banner hero-btn-color" mdxType="Hero" />
    <h1 {...{
      "id": "adobe-pdf-extract-api"
    }}>{`Adobe PDF Extract API`}</h1>
    <p>{`Unlock the structure and content elements of any PDF with a web service powered by Adobe Sensei's machine learning.`}</p>
    <p>{`apiHeroAssetImg doc-ext-invoice`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-visualizer-app/index.html"
        }}>{`Try the Demo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-extract-api"
        }}>{`Start for free`}</a></li>
    </ul>
    <WrapperComponent slots="content" repeat="1" theme="lightest" className="padding-zero Key-features-of-Adobe-PDF-Extract-API" enableMaxHeight mdxType="WrapperComponent" />
    <WhyExtractAPI mdxType="WhyExtractAPI" />
    <WrapperComponent slots="content" repeat="1" theme="light" className="How-it-works" mdxType="WrapperComponent" />
    <VisualizerHowItWorks mdxType="VisualizerHowItWorks" />
    <WrapperComponent slots="content" repeat="1" theme="lightest" className="How-it-works" mdxType="WrapperComponent" />
    <VisualizerCustomIframeBlock theme="lightest" className="video-conetnt" mdxType="VisualizerCustomIframeBlock" />
    <WrapperComponent slots="content" repeat="1" theme="light" className="Get-started-in-minutes" mdxType="WrapperComponent" />
    <ExtractStepperComponent mdxType="ExtractStepperComponent" />
    <WrapperComponent slots="content" repeat="1" theme="lightest" mdxType="WrapperComponent" />
    <PdfExtractResourceTitle mdxType="PdfExtractResourceTitle" />
    <WrapperComponent slots="content" repeat="1" theme="lightest" enableMaxWidth maxWidth='795px' mdxType="WrapperComponent" />
    <PdfExtractUseCases mdxType="PdfExtractUseCases" />
    <TextBlock slots="buttons" isCentered theme="lightest" className='padding-5' mdxType="TextBlock" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/use-cases/content-and-data-extraction/"
        }}>{`View all use cases`}</a></li>
    </ul>
    <WrapperComponent slots="content" repeat="1" theme="light" className="Explore-other-Adobe-Document-Services-APIs" mdxType="WrapperComponent" />
    <ExtractProductCard mdxType="ExtractProductCard" />
    <NewsLetterBlade className="news-letter" mdxType="NewsLetterBlade" />
    <DCSummaryBlock slots="image, heading, text, buttons" theme="lightest" background="white" className="We-are-ready-to-help" mdxType="DCSummaryBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1060px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "31.69811320754717%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/96797533521002ee15b4f820d07b2740/dda86/bg-hero.webp 265w", "/document-services/static/96797533521002ee15b4f820d07b2740/010e6/bg-hero.webp 530w", "/document-services/static/96797533521002ee15b4f820d07b2740/668f0/bg-hero.webp 1060w", "/document-services/static/96797533521002ee15b4f820d07b2740/89d57/bg-hero.webp 1590w", "/document-services/static/96797533521002ee15b4f820d07b2740/4250d/bg-hero.webp 1680w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/96797533521002ee15b4f820d07b2740/35d86/bg-hero.jpg 265w", "/document-services/static/96797533521002ee15b4f820d07b2740/7d9a0/bg-hero.jpg 530w", "/document-services/static/96797533521002ee15b4f820d07b2740/44a6b/bg-hero.jpg 1060w", "/document-services/static/96797533521002ee15b4f820d07b2740/ffe9b/bg-hero.jpg 1590w", "/document-services/static/96797533521002ee15b4f820d07b2740/e1372/bg-hero.jpg 1680w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/96797533521002ee15b4f820d07b2740/44a6b/bg-hero.jpg",
            "alt": "bg hero",
            "title": "bg hero",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "were-ready-to-help"
    }}>{`We're ready to help`}</h3>
    <p>{`Have questions about the Acrobat Services APIs?`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.com/go/pdftoolsapi_forum"
        }}>{`Go to the Adobe Forum`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../pricing/contact.md"
        }}>{`Contact us`}</a></li>
    </ul>
    {/* <APIPixelRetargeting/> */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      